var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Insect",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70853C"
    },
    d: "M32.6,5.38c-0.47,0.86,0.09,1.97,2.16,2.82c2.06,0.84,6.48,2.72,7.79,4.79s1.97,3.75,0.56,7.23 s1.97,4.04,1.97,4.04s3.47-4.13,1.41-10.04c-2.06-5.91-9.2-8.35-10.23-8.73C35.23,5.1,33.16,4.35,32.6,5.38z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7621 -0.6475 0.6475 0.7621 -55.7881 47.3415)",
    style: {
      fill: "#70853C"
    },
    cx: 36.52,
    cy: 99.58,
    rx: 5.24,
    ry: 5.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4345 -0.9007 0.9007 0.4345 -69.0267 108.6516)",
    style: {
      fill: "#70853C"
    },
    cx: 52.01,
    cy: 109.29,
    rx: 5.24,
    ry: 5.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1597 -0.9872 0.9872 0.1597 -50.7695 166.2591)",
    style: {
      fill: "#70853C"
    },
    cx: 72.28,
    cy: 112.95,
    rx: 5.24,
    ry: 5.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1597 -0.9872 0.9872 0.1597 -38.5525 188.2141)",
    style: {
      fill: "#70853C"
    },
    cx: 91.28,
    cy: 116.75,
    rx: 5.24,
    ry: 5.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#70853C"
    },
    cx: 23.8,
    cy: 53.01,
    rx: 5.14,
    ry: 4.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9964 -0.085 0.085 0.9964 -5.7186 2.3289)",
    style: {
      fill: "#70853C"
    },
    cx: 24.5,
    cy: 68.36,
    rx: 5.14,
    ry: 4.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9453 -0.3262 0.3262 0.9453 -26.0837 13.8162)",
    style: {
      fill: "#70853C"
    },
    cx: 28.16,
    cy: 84.7,
    rx: 5.4,
    ry: 5.52
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7D019"
    },
    d: "M55.41,73.57c6.19,10.42,25.34,10.28,43.5,16.19c11.92,3.88,19.29,13.09,17.88,21.68 s-7.47,10.8-12.67,10.56c-6.19-0.28-13.66-5.49-19.29-6.76c-5.63-1.27-27.92-3.47-33.79-5.91c-6.76-2.82-15.49-8.87-20.69-17.88 c-4.92-8.52-5.91-23.93-6.05-30.97s0.14-13.8-0.42-15.49s-10.03-1.77-11.97-10.28c-2.11-9.29,4.65-19.15,14.64-20.98 s22.52,2.96,25.9,14.5C55.83,39.78,50.7,65.65,55.41,73.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70853C"
    },
    d: "M30.72,62.26c-0.64,1.52,1.18,2.65,3.75,2.86c3.38,0.28,8.47-1.06,12.34-2.53 c4.04-1.54,6.55-3.45,6.55-3.45l-0.07-4.29c0,0-2.75,2.67-9.06,4.6c-3.02,0.92-7.32,1.88-8.78,1.92 C34.01,61.41,31.24,61.04,30.72,62.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70853C"
    },
    d: "M45.13,4.77c-0.93,0.72-0.35,1.94,0.42,3c0.89,1.22,2.96,3.94,3.05,6.52 c0.06,1.55-0.47,5.71-1.17,6.85c-1.17,1.92,1.36,3.33,2.63,2.53c1.55-0.97,2.2-7.33,1.92-10.04c-0.47-4.69-3.14-6.9-4.08-7.84 C47.14,5.05,45.97,4.12,45.13,4.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70853C"
    },
    d: "M98.06,89.47c0,0,0.19,6.79-0.84,10.37c-1.17,4.08-2.63,7.27-3.38,8.78 c-0.32,0.64-0.56,1.55,0.23,2.16s2.16,0.14,2.72-0.7c0.67-1.01,2.96-4.79,3.99-9.48c1.39-6.33,0.94-9.9,0.94-9.9 s-1.36-0.56-1.88-0.7C99.33,89.85,98.06,89.47,98.06,89.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70853C"
    },
    d: "M81.07,85.25c0,0,0.19,5.21-0.99,9.62c-0.8,3-2.86,7.13-3.28,7.98c-0.42,0.84-1.34,2.25-0.47,3.33 c1.25,1.56,3.26-0.33,3.92-1.78c0.43-0.96,2.4-4.19,3.59-8.78c1.36-5.26,0.99-9.53,0.99-9.53L81.07,85.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70853C"
    },
    d: "M64.32,80.7c0,0-0.49,6.73-2.11,9.76c-2.53,4.74-5.77,7.32-6.19,7.74s-2.02,1.82-0.47,2.91 c1.27,0.89,2.82,0,3.24-0.38s5.02-3.41,7.23-9.34c1.78-4.79,1.88-9.39,1.88-9.39s-1.45-0.56-1.83-0.7 C65.68,81.17,64.32,80.7,64.32,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70853C"
    },
    d: "M54.49,71.45c0,0-3.87,4.6-6.55,6.48c-3.31,2.33-7.41,3.61-8.78,3.75c-1.36,0.14-3.24,0.28-3,2.06 c0.23,1.78,2.81,1.69,4.18,1.69c2.11,0,7.13-1.99,10.35-4.34c3.07-2.24,5.91-5.77,5.91-5.77s-1.2-1.5-1.34-1.97 C55.12,72.89,54.49,71.45,54.49,71.45z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FE6014"
    },
    cx: 32.17,
    cy: 55.01,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FE6014"
    },
    cx: 32.87,
    cy: 74.93,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FE6014"
    },
    cx: 46.39,
    cy: 94.74,
    r: 3.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FE6014"
    },
    cx: 68.48,
    cy: 103.34,
    rx: 2.88,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FE6014"
    },
    cx: 87.01,
    cy: 107.78,
    rx: 2.85,
    ry: 2.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FE6014"
    },
    cx: 103.69,
    cy: 112.98,
    rx: 2.85,
    ry: 2.72
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2E27"
    },
    d: "M109.1,96.05c-2.22-1.09-3.84,2.56-4.81,6.49c-0.97,3.93-1.87,6.58,0.57,7.37 c2.98,0.96,5.12-3.45,5.86-6.85C111.46,99.66,111.13,97.04,109.1,96.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2E27"
    },
    d: "M92.99,88.84c-3.52-0.99-4.02,3.79-4.86,7.53c-0.88,3.94-3.1,7.42,0.07,8.38 c3.94,1.2,5.98-3.85,6.69-7.04C95.63,94.4,96.35,89.78,92.99,88.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2E27"
    },
    d: "M74.83,84.34c-3.68-0.99-4.18,3.71-5.35,7.72c-1.17,4.04-1.65,7.47,0.56,8.26 c2.63,0.94,4.83-2.06,6.05-6.15C77.32,90.08,78.64,85.35,74.83,84.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2E27"
    },
    d: "M49.87,92.69c2.5,2.7,6.44-0.68,8.49-3.57c1.97-2.77,5.53-7.39,2.39-9.76 c-2.67-2.02-6.02,2.2-8.02,4.83C50.95,86.54,47.48,90.11,49.87,92.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2E27"
    },
    d: "M36.26,73.66c0.6,2.41,6.29,3.1,10.75,0.52c3.15-1.82,6.8-4.65,5.96-7.93 c-0.88-3.44-6.29-0.33-9.43,0.94C40.39,68.45,35.23,69.53,36.26,73.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2E27"
    },
    d: "M52.8,48.16c-0.7-2.39-4.48,0.12-8.66,1.48c-3.73,1.22-8.87,0.99-8.59,4.88 c0.25,3.42,8.01,2,10.98,0.89C50.06,54.09,53.8,51.54,52.8,48.16z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -7.8044 40.3903)",
    style: {
      fill: "#2E2E27"
    },
    cx: 31.08,
    cy: 26.95,
    rx: 3.43,
    ry: 3.19
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsect);
export default __webpack_public_path__ + "static/media/insect.93e6baade4ff0befbe2ed299170d6e5d.svg";
export { ForwardRef as ReactComponent };